
import { Injectable, } from '@angular/core';
import { Observable, Subject, from, of } from 'rxjs';

import { SyncItemType, SyncJob } from 'src/app/models/sync.model';


import { RpaClientService } from '../net/rpa-client.service';
import { SyncHeaderJob } from './SyncHeaderJob';

import { ConnectionManagerService } from '../storage/connection-manager.service';
import { SyncDoneJob } from './SyncDoneJob';
import { SyncTimerService } from './Sync-timer.service';

import { SyncUserConnectionService } from './sync-user-connection.service';
import { LocalStorageService } from '../storage/local-storage.service';


@Injectable({
  providedIn: 'root'
})
export class SyncService {


  public jobs: SyncJob[] = []
  public running = false
  public syncEnd: Subject<boolean> = new Subject()

  constructor(

    private cm: ConnectionManagerService,
    private local: LocalStorageService,
    private httpCredit: RpaClientService,
    private syncTimerService: SyncTimerService,
    private syncUser: SyncUserConnectionService,
  ) { }

  public run(para: SyncRunParameters): Observable<boolean> {
    if (this.running) {
      return of(false)
    }

    return from(this.runSync(para))
  }


  reset() {
    // console.error("МЕТОД НЕ РЕАЛИЗОВАН. Заглушка делает вид, что произошла отмена")
    this.running = false
  }

  async runSync(para: SyncRunParameters): Promise<boolean> {

    const db = await this.cm.getDb()

    if (!db) return false

    this.running = true
    this.jobs = []


    await this.syncUser.updConn()

    const vjobber = new SyncHeaderJob("head", "Запуск", this.httpCredit, db, this.local, this.cm)



    this.jobs.push(vjobber)

    vjobber.setCat(para)
    const started = await vjobber.doWork(para.full)

    if (!started) {
      
      this.syncTimerService.setTimer(10000)
      await timeout(500)
      this.running = false

      this.running = false
      return false // TODO something!
    }

    this.jobs.push(...vjobber.result);

    let done = false
    let ok = true
    while (!done) {

      const next = this.jobs.find(j => !j.completed)
      if (next === undefined) {
        done = true
        break
      }

      const r = await next.doWork(para.full)

      if (!r) {
        ok = false
        break // TODO проверить. по-идее, после ошибки продолжать нельзя
      }

    }

    if (ok) {
      const djobber = new SyncDoneJob("done", "Завершение", this.httpCredit, db)
      this.jobs.push(djobber)
      djobber.setCat(para)
      await djobber.doWork(para.full)

    }

    this.syncTimerService.setTimer(10000)
    await timeout(500)
    this.running = false
    this.syncEnd.next(true)
    return ok


  }
 
 

}



function timeout(ms: number) {
  return new Promise(resolve => setTimeout(resolve, ms));
}



export interface SyncRunParameters {
  full: boolean,
  categories: SyncItemType[]
}